import React, { useState, useEffect } from 'react';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { useNavigate, useLocation } from 'react-router-dom';  
import { buscarEstabelecimentos, verificarSeCheckinEstaAtivoNaBase } from '../../services/api'; 
import { useParams } from 'react-router-dom';
import Carregando from '../../components/Carregando/Carregando';

// css
import './CheckinPage.css'; 
import '../../styles/global.css';
// cookies
import Cookies from 'js-cookie';

const CheckinPage = () => {
  const navigate = useNavigate();  
  const location = useLocation();  

  // const [carregando, setCarregando] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [error, setError] = useState(null);
  const [estabelecimentos, setEstabelecimentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = JSON.parse(sessionStorage.getItem('userData')) || {};

  const {params} = useParams(); // tentar capturar os dados vindos do pagbank

  // vamos pegar o dadosCheckin da sessão e depois a gente verifica se tem algo nos cookies
  const dadosCheckin = JSON.parse(sessionStorage.getItem('dadosCheckin')) || {};



  useEffect(() => {
    console.log('----- ENTROU NO CHECKINPAGE -----');

    if (params) {
      const dadosRetorno = JSON.parse(params);

      console.log('params: ');
      
      console.log(dadosRetorno);
      // Processar os dados de retorno
    }
    
    // vamos chamar o método que faz as verificações do checkin, inclusive nos cookies.
    verificarDadosCheckin();  // se for verificado o checkin, já será redirecionado.

    // vamos chamar o método que carrega os dados
    loadData();

  }, []);
   

  // if (carregando) {
  //   return <Carregando />;
  // }

  /**
   * Este método verifica na sessão se o usuário já fez checkin.
   * Se não tiver na sessão, verifica nos cookies.
   * Se tiver feito checkin, já redireciona para a página de usuário checkado.
   */
  const verificarDadosCheckin = () => {

      // verificar se tem dadosCheckin na sessão
      if (Object.keys(dadosCheckin).length === 0) {
        console.log('dadosCheckin está vazio');
        console.log('vamos verificar se tem cookies...');

        // verificar se tem dadosCheckin nos cookies
        const cookieValue = Cookies.get('dadosCheckin');
        if (cookieValue === undefined || cookieValue === null || cookieValue === '') {
          console.log('Cookie está vazio');
        } else {
          // const cookies = Cookies.get();
          console.log('TEM Cookies:');
          
          const dadosCookies = JSON.parse(Cookies.get('dadosCheckin'))
          console.log(dadosCookies);

          console.log('salvando dados na sessão...');

          // vamos salvar os dados que estão nos cookies, na sessão
          sessionStorage.setItem('dadosCheckin', JSON.stringify({
            estabelecimento: dadosCookies.estabelecimento,
            objBarcheckin: dadosCookies.objBarcheckin,
            statusCheckin: dadosCookies.statusCheckin
          }));

          // vamos verificar se o usuário já fez checkin
          if( dadosCookies.statusCheckin === 'usuarioCheckado' ){
            console.log('Usuário será redirecionado para a página de usuário checkado.');
            navigate('/usuario-checkado', { dadosCheckin: { dadosCheckin } });
          }
        } 

      } else {
        // aqui quer dizer que tem dadosCheckin na sessão. Vamos confirmar se o usuário fez checkin
        if( dadosCheckin.statusCheckin === 'usuarioCheckado' ){
          /**
           * aqui quer dizer que temos dados do checkin na seção.
           * vamos verificar se o checkin ainda existe na base de dados
           */
          fetchDadosCheckinNaBase();

          // aqui tudo certo, vamos redirecionar o usuário para a página de usuário checkado
          console.log('Usuário será redirecionado para a página de usuário checkado.');
          navigate('/usuario-checkado', { dadosCheckin: { dadosCheckin } });
        }
      }

  }

  // método que pega a localização e busca os estabelecimentos
  const loadData = async () => {
    console.log(' *** Entrou no loadData ***');
    try {
      await getLocation(); 
      await fetchEstabelecimentos(); 
    } catch (err) {
      console.log("Erro ao capturar localização ou buscar estabelecimentos:", err);
    }
  };


  const handleClick = (estabelecimento) => {
    navigate('/mostrar-dados-estabelecimento', { state: { estabelecimento } });
  };

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;

            if (latitude === 0 && longitude === 0) {
              reject("Localização inválida recebida (0,0).");
              return;
            }

            setLatitude(latitude);
            setLongitude(longitude);

            const updatedUserData = { ...userData, latitude, longitude };

            sessionStorage.setItem('userData', JSON.stringify(updatedUserData));
            sessionStorage.setItem('latitude', latitude);
            sessionStorage.setItem('longitude', longitude);

            resolve({ latitude, longitude });
          },
          (err) => {
            setError(err.message);
            reject(err);
          }
        );
      } else {
        const errorMessage = "Geolocalização não suportada pelo navegador.";
        setError(errorMessage);
        reject(errorMessage);
      }
    });
  };

  const fetchEstabelecimentos = async () => {
    const storedUserData = JSON.parse(sessionStorage.getItem('userData')) || {};

    if (storedUserData.latitude && storedUserData.longitude && storedUserData.latitude !== 0 && storedUserData.longitude !== 0) {
      try {
        const response = await buscarEstabelecimentos(storedUserData); 
        setEstabelecimentos(response.estabelecimentos); 
      } catch (error) {
        setError("Erro ao carregar os estabelecimentos");
      } finally {
        setLoading(false); 
        // setCarregando(false);
      }
    } else {
      setError("Localização inválida. Não foi possível buscar os estabelecimentos.");
      setLoading(false);
      // setCarregando(false);
    }
  };

  const fetchDadosCheckinNaBase = async () => {
    console.log('Entrou em fetchDadosCheckinNaBase....');
    try {
      const response = await verificarSeCheckinEstaAtivoNaBase(dadosCheckin); 
      console.log('Response: ');
      console.log(response);
      // vamos verificar o retorno, para sabermos se vamos excluir os dados da seção
      const is_checkin_ativo = response.is_checkin_ativo;
      if (!is_checkin_ativo) {
        // Aqui o checkin está inativo. Vamos excluir da seção e dos cookies e redirecionar o usuário 
        console.log('Checkin INATIVO! Removendo da seção e dos cookies...');
        sessionStorage.removeItem('dadosCheckin');
        Cookies.remove('dadosCheckin');
        navigate('/');

      }
      
    } catch (error) {
      setError("Erro ao buscar dados do checkin na base!");
      console.log('Erro: ');
      console.log(error);
    }
  };

  // Função para redirecionar para CardapioPage
  const handleGoToCadastrarEstabelecimento = () => {
    console.log('Entrou em handleGoToLerQrCodeEstabelecimento');
    navigate('/form-cadastrar-gerente'); // Redireciona para a página de cadastro
  };



  const BASE_API =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://127.0.0.1:8000'
      : 'https://mercadinhointeligente.com.br';

  return (

    <div className="checkin-container">
      <TituloComponent /> 

      {loading ? (
        <div className="box-dados">
          <p className="texto-welcome">Carregando, aguarde...</p>
        </div>
      ) : (
        <>
          <div className="logobar-carousel">
            {estabelecimentos.length > 0 ? (
              estabelecimentos.map((estab) => {
                const imageUrl = `${BASE_API}/storage/imagens/bares/${estab.id}.png`;

                return (
                  <div  className="logobar-item" key={estab.id} onClick={() => handleClick(estab)} >
                    <img 
                      src={imageUrl} 
                      alt={estab.nome} 
                      className="logobar-image" 
                    />
                    <p className="logobar-nome" >{estab.nome}</p>
                  </div>
                );
              })
            ) : (
              <p>Nenhum estabelecimento encontrado.</p>
            )}
          </div>

          <div className="quadro-qr-code-checkin" onClick={handleGoToCadastrarEstabelecimento}>
              {/* <h3>Cadastrar meu Estabelecimento</h3> */}
              <p  >Clique aqui e transforme seu estabelecimento em</p>
              <h3>Bar Inteligente</h3>
          </div>
        </>
      )}
    </div>
    
  );
};

export default CheckinPage;
